import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandLogo',
  setup(__props) {

const BRAND = window.config.BRAND

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(BRAND) === 'kuebler')
      ? (_openBlock(), _createElementBlock("img", _mergeProps({ key: 0 }, _ctx.$attrs, {
          src: require('@/assets/image/logo.svg')
        }), null, 16, _hoisted_1))
      : _createCommentVNode("", true),
    (_unref(BRAND) === 'snabble')
      ? (_openBlock(), _createElementBlock("img", _mergeProps({ key: 1 }, _ctx.$attrs, {
          src: require('@/assets/image/snabble/logo.svg')
        }), null, 16, _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})